import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

export default function SelectControl(props) {
	
    const [getValue, setValue] = useState(false);		

	const onChange=(e)=>{
		if(props.onChange)
			props.onChange(e.target.value,e)
	}
	
	const onClick=(e)=>{
		if(props.onClick)
			props.onClick(e.target.value,e)
	}	

    return (
		<div>
			<div>
				{props.title}
				<span className="text-danger fw-bold">{props.required ? "*" : ""}</span>
			</div>	

			<Form.Select id={props.id} required={props.required} valid="comboBox" disabled={props.disabled ? true : false} ref={props.inputRef} onChange={onChange} dataValue={props.dataValue} onClick={onClick} className={props.className==undefined?'':props.className + ' comboSelectRow'}>
				{props.selected == null && <option value="0" selected="selected">انتخاب کنید</option>} 
				{props.selected != null && <option value="0">انتخاب کنید</option>} 
				{props.data.map((item) => (
					props.selected && (item.ID==props.selected || item.id==props.selected) ?  
					<option
						className="text-xs" 
						key={item.id ? item.id : item.ID}
						selected="selected" 
						value={item.id ? item.id : item.ID}> 
						{item.title ? item.title : item.Title}
					</option>
					:					
					<option
						className="text-xs" 
						key={item.id ? item.id : item.ID}
						value={item.id ? item.id : item.ID}> 
						{item.title ? item.title : item.Title}
					</option>
				))}
			</Form.Select>
		</div>
    )
}